import React from 'react';
import { FormControl, InputGroup } from 'react-bootstrap';
import { AiOutlineDribbble, AiOutlineTwitter } from 'react-icons/ai';
import { FaFacebookF, FaLinkedinIn, FaPinterestP } from 'react-icons/fa';
import { MdOutlineSlowMotionVideo } from 'react-icons/md';
import { Link } from 'react-router-dom';
import './Footer.scss';
import footerImg from '../../assets/img/Image 4.png'

const Footer = () => {
    return (
        <footer id="footer" className='d-flex'>
            <div className='emptyDiv hidden xl:block opacity-0'>a</div>
            <div className="mx-auto 2xl:container w-100">
                <div className='footerTop d-flex justify-around lg:justify-between'>
                    <div className='socialIcons d-flex items-center'>
                        <Link to="/" className="icons">
                            <FaFacebookF />
                        </Link>
                        <Link to="/" className="icons">
                            <AiOutlineTwitter />
                        </Link>
                        <Link to="/" className="icons">
                            <FaPinterestP />
                        </Link>
                        <Link to="/" className="icons">
                            <MdOutlineSlowMotionVideo />
                        </Link>
                        <Link to="/" className="icons">
                            <FaLinkedinIn />
                        </Link>
                        <Link to="/" className="icons">
                            <AiOutlineDribbble />
                        </Link>
                    </div>
                    <div className='footerNav hidden lg:block'>
                        <Link to="/" className="link">Blog</Link>
                        <Link to="/" className="link">Affiliates</Link>
                        <Link to="/" className="link">Pricing</Link>
                        <Link to="/" className="link">Downloads</Link>
                        <Link to="/" className="link">Live Demos</Link>
                        <Link to="/" className="link">Promotions</Link>
                    </div>
                    <div className='block lg:hidden'>
                        <ul>
                            <li>
                                <Link to="/" className="link">Blog</Link>
                            </li>
                            <li>
                                <Link to="/" className="link">Affiliates</Link>
                            </li>
                            <li>
                                <Link to="/" className="link">Pricing</Link>

                            </li>
                            <li>
                                <Link to="/" className="link">Downloads</Link>

                            </li>
                            <li>
                                <Link to="/" className="link">Live Demos</Link>

                            </li>
                            <li>
                                <Link to="/" className="link">Promotions</Link>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className='footerMain row'>
                    <div className="col-md-4 col-lg-2">
                        <div className='d-flex flex-column'>
                            <Link to="/" className="link active">Quick Links</Link>
                            <Link to="/" className="link">Home</Link>
                            <Link to="/shop" className="link">Shop</Link>
                            <Link to="/" className="link">Account</Link>
                            <Link to="/cart" className="link">Cart</Link>
                        </div>
                    </div>
                    <div className="col-md-4 col-lg-2">
                        <div className='d-flex flex-column'>
                            <Link to="/" className="link active">Products</Link>
                            <Link to="/" className="link">Product #1</Link>
                            <Link to="/" className="link">Product #2</Link>
                            <Link to="/" className="link">Product #3</Link>
                            <Link to="/" className="link">Product #4</Link>
                        </div>
                    </div>
                    <div className="col-md-4 col-lg-2">
                        <div className='d-flex flex-column'>
                            <Link to="/" className="link active">Supports</Link>
                            <Link to="/" className="link">Call Center</Link>
                            <Link to="/" className="link">Documentation</Link>
                            <Link to="/" className="link">FAQs</Link>
                            <Link to="/" className="link">Policies</Link>
                        </div>
                    </div>
                    <div className="col-md-4 col-lg-2">
                        <div className='d-flex flex-column'>
                            <Link to="/" className="link active">Terms</Link>
                            <Link to="/" className="link">Terms of Use</Link>
                            <Link to="/" className="link">Delivery</Link>
                            <Link to="/" className="link">Refund Policy</Link>
                            <Link to="/" className="link">Privacy Policy</Link>
                        </div>
                    </div>
                    <div className='col-md-7 col-lg-4'>
                        <div className='d-flex flex-column'>
                            <Link to="/" className="link active">Newsletter</Link>
                            <span className="link">We provide excellent offers and discount from time to time, subscribe today so that you don't miss out!</span>
                        </div>
                        <InputGroup className='news__form'>
                            <FormControl
                                type="text"
                                placeholder="email address"
                            />
                            <InputGroup.Text id="btnGroupAddon">Subscribe</InputGroup.Text>
                        </InputGroup>
                    </div>
                </div>
                <div className='hidden lg:block footerBottom'>
                    <div className='d-flex items-center justify-between'>
                        <p>All right reserved by Bubu ShopKpr Technologies Pvt.ltd.©2020-2025</p>
                        <img src={footerImg} alt="" className='' />
                    </div>
                </div>
                <div className='block lg:hidden footerBottom '>
                    <p className='mb-3 text-center'>All right reserved by ShopKpr Technologies Pvt.ltd.©2020-2025</p>
                    <img className='mx-auto' src={footerImg} alt="" />
                </div>
            </div>
        </footer>
    );
};

export default Footer;